<template>
  <!--begin::Wrapper-->
  <div class="w-100">
    <!--begin::Input group-->
    <div class="fv-row">
      <div class="row">
        <!-- nombre completo familiar -->
        <div class="col-md-5 mt-3">
          <label class="form-label">Nombre completo familiar:</label>
          <Field
            name="nombre_familiar"
            v-slot="{ field }"
            v-model="formData.nombre_familiar"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              id="nombre_familiar"
              style="text-transform: uppercase"
              :disabled="disabled"
              v-model="formData.nombre_familiar"
            />
          </Field>
          <ErrorMessage
            name="nombre_familiar"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- parentesco -->
        <div class="col-md-3 mt-3">
          <label class="form-label">Parentesco:</label>
          <Field
            name="parentesco"
            v-slot="{ field }"
            v-model="formData.parentesco"
          >
            <select
              v-model="formData.parentesco"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
              :disabled="disabled"
            >
              <option
                v-for="(list, key) in relationshipList"
                :value="list.id_parentesco"
                :key="key"
              >
                {{ list.nombre_parentesco }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="parentesco"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- número de telefono -->
        <div class="col-md-2 mt-3">
          <label class="form-label">Nro. telefono:</label>
          <Field
            name="numero_telefono"
            v-slot="{ field }"
            v-model="formData.numero_telefono"
          >
            <input
              v-bind="field"
              type="number"
              class="form-control fuente"
              id="telefonoCelular"
              min="1"
              pattern="^[0-9]+"
              :disabled="disabled"
              v-model="formData.numero_telefono"
            />
          </Field>
          <ErrorMessage
            name="numero_telefono"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- BTN AGREGAR -->
        <div class="col-md-2 mt-7">
          <button
            type="button"
            style="margin: 5px"
            class="btn btn-primary px-3"
            :disabled="
              !formData.nombre_familiar || !formData.parentesco || disabled
            "
            @click="addFamily()"
          >
            Agregar
          </button>
        </div>
      </div>
      <template>
        <Field name="family" v-model="family"> </Field>
        <ErrorMessage
          name="family"
          class="fv-plugins-message-container invalid-feedback"
        ></ErrorMessage>
      </template>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">N°</th>
          <th scope="col">Acciones</th>
          <th scope="col">Nombre Familiar</th>
          <th scope="col">Parentesco</th>
          <th scope="col">Teléfono</th>
        </tr>
      </thead>
      <tbody>
        <span v-if="family.length === 0">
          No existen registros de familiares.
        </span>
        <tr v-else v-for="(value, index) in family" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>
            <button
              type="button"
              class="btn px-3"
              @click="editRecord(value, index)"
              :disabled="disabled"
              v-if="!disabledEdit"
            >
              <i
                title="Editar "
                style="font-size: 1.5em; color: Dodgerblue"
                class="fas fa-pencil"
              ></i>
            </button>
            <button
              type="button"
              class="btn px-3"
              :disabled="disabled"
              @click="deleteRecord(index)"
            >
              <i
                title="Eliminar"
                style="font-size: 1em; color: Mediumslateblue"
                class="fas fa-xmark fa-lg"
              ></i>
            </button>
          </td>
          <td>{{ value.nombre_familiar.toUpperCase() }}</td>
          <td>{{ familiarName(value.parentesco) }}</td>
          <td>{{ value.numero_telefono }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  onBeforeUpdate,
  // onUpdated,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Field, ErrorMessage } from "vee-validate";
import filiation from "@/filiation/composables/useFiliation";
import { useRoute } from "vue-router";
//import Datatable from "@/components/kt-datatable/KTDatatable.vue";
export default defineComponent({
  name: "familyData",
  components: {
    //vSelect,
    //Datepicker,
    //  Datatable,
    Field,
    ErrorMessage,
    //Loading,
  },
  setup() {
    const disabledEdit = ref(false);
    const disabled = ref(false);
    const route = useRoute();
    const formData = reactive({
      nombre_familiar: "",
      parentesco: "",
      numero_telefono: "",
      id_familiaresppl: 0,
    });
    const family = reactive([]);
    const relationshipList = ref([]);
    const { relationships, dataToEdit } = filiation();
    const relationship = async () => {
      const { data } = await relationships();
      relationshipList.value = data;
    };
    const addFamily = async () => {
      family.push({ ...formData });
      resetFields();
    };
    const resetFields = () => {
      formData.nombre_familiar = "";
      formData.parentesco = "";
      formData.numero_telefono = "";
      formData.id_familiaresppl = 0;
    };
    const familiarName = (value) => {
      if (relationshipList.value.length === 0) {
        return;
      } else {
        const fam = relationshipList.value.find(
          (item) => item.id_parentesco === value
        );
        return fam.nombre_parentesco;
      }
    };
    const deleteRecord = (value) => {
      family.splice(value, 1);
      //   for (let i = 0; i < family.value.length; i++) {
      //     if (family.value[i].invoice === invoice) {
      //       family.value.splice(i, 1);
      //     }
      //   }
    };
    const editRecord = (value, index) => {
      for (let i in family) {
        if (i == index) {
          formData.nombre_familiar = family[i].nombre_familiar;
          formData.parentesco = family[i].parentesco;
          formData.numero_telefono = family[i].numero_telefono;
          formData.id_familiaresppl = family[i].id_familiaresppl;
          break;
        }
      }
      deleteRecord(index);
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    //console.log(dataEdit);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Datos familiares", [
        "Registro privado de libertad",
      ]);
      relationship();
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        disabledEdit.value = true;
        const data = JSON.parse(localStorage.getItem("edit") || "{}");
        let i = data.familiares.length;
        while (i--) {
          family[i] = data.familiares[i];
        }
      }
    });
    return {
      disabledEdit,
      relationshipList,
      formData,
      family,
      disabled,
      dataEdit,
      addFamily,
      familiarName,
      deleteRecord,
      editRecord,
    };
  },
});
</script>
<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
